import { Alert as DSAlert } from "@artprov/design-system";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

// Mapeo de variantes personalizadas a las aceptadas por el design system
const VARIANT_MAP = {
  success: "success",
  error: "error",
  info: "neutral",
  warning: "warning",
  primary: "neutral",
  selected: "warning",
  default: "neutral",
  disabled: "error",
};

// Ícono personalizado por variante (sobreescribe el default del DS)
const VARIANT_ICONS = {
  error: "cancel",
  success: "check_circle",
};
const VARIANT_ICON_STYLES = {
  error: "!text-error-30",
  success: "!text-success-30",
};

const VARIANT_COLORS = {
  success: "",
  error: "",
  info: "bg-info-10 border-info-30 text-info-10",
  warning: "bg-warning-10 border-warning-30 text-warning-10",
};

const CLOSE_BUTTON_STYLE = "[&>div]:!text-tertiary-10";

export default function Alert({
  description,
  variant = "success",
  topClass = "top-[90px]",
  rightClass = "right-[20px]",
  absolute = false,
  zIndexClass = "z-[10000]",
  className = "",
  onClose,
  autoHideMs = 3000,
}) {
  const [visible, setVisible] = useState(true);
  const positionClass = absolute ? "absolute" : "fixed";

  const handleClose = () => {
    setVisible(false);
    if (typeof onClose === "function") onClose();
  };

  useEffect(() => {
    if (autoHideMs && autoHideMs > 0) {
      const timer = setTimeout(() => {
        setVisible(false);
        if (typeof onClose === "function") onClose();
      }, autoHideMs);
      return () => clearTimeout(timer);
    }
  }, [autoHideMs, onClose]);

  if (!visible) return null;

  const dsVariant = VARIANT_MAP[variant] || "neutral";
  const containerStyle = VARIANT_COLORS[variant] || "";
  const icon = VARIANT_ICONS[variant];
  const iconStyle = VARIANT_ICON_STYLES[variant] || "";

  return (
    <div className={`${positionClass} ${topClass} ${rightClass} ${zIndexClass} ${className}`}>
      <DSAlert
        variant={dsVariant}
        title={description}
        titleStyle="whitespace-pre-line"
        onClose={handleClose}
        containerStyle={containerStyle}
        iconStyle={iconStyle}
        buttonStyle={CLOSE_BUTTON_STYLE}
        {...(icon && { icon })}
      />
    </div>
  );
}

Alert.propTypes = {
  description: PropTypes.string,
  variant: PropTypes.string,
  topClass: PropTypes.string,
  rightClass: PropTypes.string,
  absolute: PropTypes.bool,
  zIndexClass: PropTypes.string,
  className: PropTypes.string,
  onClose: PropTypes.func,
  autoHideMs: PropTypes.number,
};